export default "__VITE_ASSET__z$i6vH5$__"